import React from 'react';
import { connect } from 'react-redux';

import { NavigationLocationState } from 'app/modules/Navigation/types';
import { ReduxState } from 'app/redux/types';

import { currentLocation } from 'app/modules/Navigation/selectors';
import ErrorBoundary from 'app/widgets/ErrorBoundary';
import NotFound from 'app/widgets/Errors/NotFound';

import { AllSportsGrid } from './AllSportsGrid';
import Announcement from './Announcement';
import Favorites from './Favorites';
import MatchCenterLive from './MatchCenter';
import SportGrid from './SportGrid';
import { StageGrid } from './StageGrid';

type LiveContentProps = Pick<NavigationLocationState, (
  'list' |
  'sportId' |
  'tournamentStageId' |
  'matchId'
)>;

const LiveContent: React.FC<LiveContentProps> = ({
  list,
  sportId,
  tournamentStageId,
  matchId,
}) => {
  if (matchId) {
    return (
      <ErrorBoundary>
        <MatchCenterLive />
      </ErrorBoundary>
    );
  }

  if (tournamentStageId) {
    return (
      <ErrorBoundary>
        <StageGrid />
      </ErrorBoundary>
    );
  }

  if (sportId && !list) { // also handles `tournamentId`
    return (
      <ErrorBoundary>
        <SportGrid sportId={sportId} />
      </ErrorBoundary>
    );
  }

  switch (list) {
    case null:
      return (
        <ErrorBoundary>
          <AllSportsGrid />
        </ErrorBoundary>
      );

    case 'favorites':
      return (
        <ErrorBoundary>
          <Favorites />
        </ErrorBoundary>
      );

    case 'announcement':
      return (
        <ErrorBoundary>
          <Announcement />
        </ErrorBoundary>
      );

    default:
      return <NotFound />;
  }
};

const mapStateToProps = (state: ReduxState): LiveContentProps => {
  const {
    list,
    sportId,
    tournamentStageId,
    matchId,
  } = currentLocation(state);

  return {
    list,
    sportId,
    tournamentStageId,
    matchId,
  };
};

export default connect(mapStateToProps)(LiveContent);
